/** Card with a grey title bar used to group fields on form/info pages. */
const FormSection = ({
  icon: Icon,
  title,
  bordered = true,
  className = "mt-4",
  bodyClassName = "px-2 pt-1 pb-3",
  children,
}) => (
  <div
    className={`${className} ${bordered ? "border " : ""}bg-white rounded-[4px] overflow-hidden`}
  >
    <div className="flex items-center bg-gray-200 p-2.5">
      <Icon className="text-[18px] text-black " />
      <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
        {title}
      </span>
    </div>
    <div className={bodyClassName}>{children}</div>
  </div>
);

export default FormSection;
